import { render, staticRenderFns } from "./notopen.vue?vue&type=template&id=364771aa&scoped=true"
import script from "./notopen.vue?vue&type=script&lang=js"
export * from "./notopen.vue?vue&type=script&lang=js"
import style0 from "./notopen.vue?vue&type=style&index=0&id=364771aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364771aa",
  null
  
)

export default component.exports